import script from "./Education.vue?vue&type=script&setup=true&lang=js"
export * from "./Education.vue?vue&type=script&setup=true&lang=js"

import "./Education.vue?vue&type=style&index=0&id=281e42d9&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-281e42d9"]])

export default __exports__